<template lang="pug">

	#searchApp(:class="{ 'active' : search.active }")
		.search-bar
			.search-input
				input(placeholder="Start typing..." v-model="search.query" @keyup="performSearch()" ref="searchInput")
			.search-close(@click="toggleSearch(false)")
				include ../../../pug/partials/icon-close.pug

		.search-results(ref="searchResults" v-if="search.searching")
			.results-count(v-if="totalSearchResults > 0")
				span {{ totalSearchResults }} results found for "{{ search.query }}"...
			.results-count(v-else)
				span No results found for "{{ search.query }}"...
			.results-list
				template(v-for="(result, index) in search.results")
					.pb-4(v-if="result.hits.length > 0") 
						span.capitalize.pr-2 {{ result.index }} ({{ result.hits.length }} results)
					.search-result-group(v-if="result.hits.length > 0")
						template(v-for="(hit, index) in result.hits")
							a.search-result-item(
								:href="hit.url"
								@click="toggleSearch(false)"
							)
								.search-result-image
									img(v-if="hit.hero_image" :src="'/img/assets/'+hit.hero_image+'?w=600&h=420&fit=crop'"  :alt="hit.title")
									img(v-else-if="hit.profile_image" :src="'/img/assets/'+hit.profile_image+'?w=600&h=420&fit=crop'"  :alt="hit.title")
									img(v-else :src="'/img/img/no-image.png?w=600&h=420&fit=crop'" :alt="hit.title")
								p.hit-title {{ hit.title }}
								.index-title {{ result.index }}
								include ../../../pug/partials/icon-arrow.pug
					
</template>

<script>

// Aloglia Search
const algoliasearch = require('algoliasearch');
const client = algoliasearch('909MIE8JWU', '1f231631ec7d6f7b2cbb1c4a85377aff');

export default {
	el: "search",
	name: "Search",
	data() {
		return {
			loading: false,
			search: {
				active: false,
				searching: false,
				query: '',
				results: []
			}
		}
	},
	watch: {
		search: {
			handler: function(val, oldVal) {
				if (val.active) {
					document.body.classList.add('overflow-hidden')
				} else {
					document.body.classList.remove('overflow-hidden')
				}
			},
			deep: true
		}
	},
	methods: {
		toggleSearch(force = null) {
			if (force !== null) {
				this.search.active = force;
				if (force === false) {
					window.dispatchEvent(new CustomEvent('hideoverlay'))
					this.search.searching = false
				} else {
					window.dispatchEvent(new CustomEvent('showoverlay'))
				}
			} else {
				this.search.active = !this.search.active;
				window.dispatchEvent(new CustomEvent('toggleoverlay'))
			}

			if (this.search.active) {
				this.$refs.searchInput.focus()
				this.mobileNav = false
			} else {
				this.search.results = []
				this.search.query = ''
				this.search.searching = false
			}
		},
		performSearch() {

			this.search.searching = false

			if (this.search.query.length < 3) {
				this.search.results = []
				return // only run if more than 3 characters
			}

			const queries = [
				{
					indexName: 'people',
					query: this.search.query,
					filters: 'status:published'
				}, {
					indexName: 'projects',
					query: this.search.query,
					filters: 'status:published'
				}, {
					indexName: 'news',
					query: this.search.query,
					filters: 'status:published'
				}
				
			];

			let r = []

			client.multipleQueries(queries).then(({ results }) => {
				results.forEach(result => {
					let res = {}
					res.index = result.index
					res.hits = result.hits
					r.push(res)
				})
				this.search.searching = true
			});

			this.search.results = r;

		}
	},
	computed: {
		totalSearchResults() {
			return this.search.results.reduce((acc, result) => {
				return acc + result.hits.length
			}, 0)
		}
	},
	mounted() {
		window.addEventListener('opensearch', () => {
			console.log('event opensearch')
			this.toggleSearch()
		})
	}
}
</script>
